import React from "react";
import { useRouteMatch, Link, useLocation, useHistory } from "react-router-dom";
import { useAuthState } from "../../../components/AuthProvider";
import CompareRecords from "../../NewSearchRecords/SearchRecordTable/CompareRecords";
import fetchConfig from "../../../utils/fetchConfig";
import handleResponse from "../../../utils/handleFetchResponse";
import { useMessageToast } from "../../../components/MessageProvider";
import Button from "../../../components/Button";
import Spinner from "../../../components/Loader/Spinner";

import styles from "./OverlayReviewQueue.module.scss";
import { aggregatesCall } from "../../../utils/fetchData";

function OverlayReviewQueue() {
  const { user } = useAuthState();
  let { path, url } = useRouteMatch();
  const location = useLocation();
  const history = useHistory();

  const {
    selectedClient: { oid: clientId }
  } = user.preferences;
  const userId = user.username;
  const toast = useMessageToast();

  const [
    OverlayRecordLoadingState,
    setOverlayRecordLoadingState
  ] = React.useState(false);
  const [overlayData, setOverlayData] = React.useState([]);
  const [overlayRecordId, setOverlayRecordId] = React.useState("");
  const [
    overlayRecordSourceSystem,
    setOverlayRecordSourceSystem
  ] = React.useState("");

  const [isRecordOverridden, setIsRecordOverridden] = React.useState(false);

  const constructOverlayRecordsData = React.useCallback(overlayRecordsData => {
    const preOverlayRecordDemographics = JSON.parse(
      overlayRecordsData.overlayRecord.demographics
    );
    const postOverlayRecordDemographics = JSON.parse(
      overlayRecordsData.currentRecord.demographics
    );
    setOverlayData([
      preOverlayRecordDemographics,
      postOverlayRecordDemographics,
      postOverlayRecordDemographics
    ]);
  }, []);

  const fetchOverlayRecord = React.useCallback(() => {
    setOverlayRecordLoadingState(true);
    let url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/nextoverlay`;
    if (location.state.sourceEntityId && location.state.sourceSystemId) {
      url =
        url +
        "?sourceEntityId=" +
        location.state.sourceEntityId +
        "&sourceSystemId=" +
        location.state.sourceSystemId;
    }
    url = encodeURI(url);
    const mockUrl = `/OverlayRecord.json`;
    const config = {
      method: "GET",
      credentials: "include",
      headers: {
        clientId: clientId,
        userId: userId
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        let isrestricted = response.isRestricted == "true" ? true : false;
        let restrictedeids = response.RestrictedEids;
        if (
          isrestricted &&
          restrictedeids != "null" &&
          restrictedeids.length > 0
        ) {
          restrictedeids = restrictedeids
            .replaceAll(/Patient\/|\[|\]/gi, "")
            .split("/");
          toast.info(
            "You are not authorized to view Overlay record " +
              restrictedeids[0] +
              " due to data governance restriction/compliance."
          );
          history.push("/review-queue-dashboard");
        }
        setOverlayRecordLoadingState(false);
        if (response.data) {
          setOverlayRecordId(response.data.overlayRecord.sourceEntityId);
          setOverlayRecordSourceSystem(
            response.data.overlayRecord.sourceSystem
          );
          constructOverlayRecordsData(response.data);
        }
      })
      .catch(error => {
        console.log("fetchOverlayRecord error: ", error);
        setOverlayRecordLoadingState(false);
        if (
          error &&
          error.toString() &&
          error.toString().includes("SyntaxError: Unexpected token")
        ) {
          toast.error("Overlay Record not found");
        } else {
          toast.error("Error in fetching Overlay Record");
        }
        history.push("/review-queue-dashboard");
      });
  }, [toast, constructOverlayRecordsData, clientId, userId]);

  const recordOverrideHandler = type => {
    const currentOverlayValue =
      type === "preOverlay" ? overlayData[0] : overlayData[1];
    const preOverlayValue = overlayData[0];
    const postOverlayValue = overlayData[1];

    setOverlayData([preOverlayValue, postOverlayValue, currentOverlayValue]);
    setIsRecordOverridden(!isRecordOverridden);
  };
  const { selectedClient } = user.preferences;
  const handleFocusIdentity = (Record_ID, Source_System) => {
    setOverlayRecordLoadingState(true);
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/aggregates`;
    const mockUrl = `/fhirPatients.json`;
    const config = {
      method: "POST",
      body: JSON.stringify({
        ids: [{ value: Record_ID }],
        sourceId: Source_System
      }),
      credentials: "include",
      headers: {
        clientId: selectedClient.oid,
        "Content-Type": "application/json"
      }
    };

    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        setOverlayRecordLoadingState(false);
        history.push({
          pathname: `/search-identities-new/${clientId}/view/${response.data[0].id}/`,
          state: {
            preLoadedSearchCriteria: [
              {
                key: "golden_id",
                label: "HCM ID/EID",
                value: response.data[0].id
              }
            ]
          }
        });
      })
      .catch(error => {
        setOverlayRecordLoadingState(false);
        toast.error("Focus Identity not found");
      });
  };

  const focusIdentityButtonHandler = (Record_ID, Source_System) => {
    return (
      <Button
        className={styles.nextArrowIcon}
        onClick={() => handleFocusIdentity(Record_ID, Source_System)}
      >
        Focus Identity
      </Button>
    );
  };

  const skipAndReviewHandler = async (status, fromSearchOverlay) => {
    const org_name = user.preferences.selectedClient.organization.name;
    const res = await aggregatesCall(
      overlayRecordId,
      overlayRecordSourceSystem,
      user
    );
    setOverlayRecordLoadingState(true);
    let url = `${process.env.REACT_APP_CLIENT_CONFIG_API_V1_DOMAIN}/rpc/overlayReviewQueueItems/update/?client_id=${clientId}&source_system_id=${overlayRecordSourceSystem}&overlay_status=${status}&source_entity_id=${overlayRecordId}&user_id=${userId}&org_name=${org_name}&golden_id=${res.gid}&risk_score=${res.risk_score}`;
    url = encodeURI(url);
    const config = {
      method: "PUT",
      headers: {
        user_id: userId
      }
    };
    fetch(url, config)
      .then(handleResponse)
      .then(() => {
        setOverlayRecordLoadingState(false);
        if (fromSearchOverlay) {
          toast.success("Overlays review queue item successfully reviewed");
        } else {
          fetchOverlayRecord();
        }
      })
      .catch(error => {
        setOverlayRecordLoadingState(false);
        toast.error(
          `Failed to ${
            status === "Reviewed" ? "review" : "skip"
          } item in the Overlays review queue`
        );
      });
  };

  const applyAndResolveOverlayRecordHandler = (
    currentOverlayRecordDemographics,
    fromSearchOverlay
  ) => {
    let overlay_request = JSON.parse(
      JSON.stringify(currentOverlayRecordDemographics)
    );
    if (overlay_request.meta.lastUpdated) {
      delete overlay_request.meta.lastUpdated;
    }

    setOverlayRecordLoadingState(true);
    const url = `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patientsource`;
    const mockUrl = `/OverlayRecord.json`;
    const config = {
      method: "POST",
      body: JSON.stringify(overlay_request),
      credentials: "include",
      headers: {
        clientId: clientId,
        userId: userId,
        "Content-Type": "application/json",
        "source-of-request": "HCM Admin UI",
        sourceId: overlayRecordSourceSystem,
        recordCombiner: "NewOnly",
        ignoreVersionCheck: "true"
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        setOverlayRecordLoadingState(false);
        skipAndReviewHandler("Reviewed", fromSearchOverlay);
      })
      .catch(error => {
        console.log("applyAndResolveOverlayRecordHandler error: ", error);
        setOverlayRecordLoadingState(false);
        toast.error("Error occured while applying changes");
      });
  };

  React.useEffect(() => {
    fetchOverlayRecord();
  }, [fetchOverlayRecord]);

  return (
    <div>
      {OverlayRecordLoadingState ? (
        <Spinner />
      ) : (
        overlayData.length &&
        overlayRecordSourceSystem.length > 0 &&
        overlayRecordId.length > 0 && (
          <CompareRecords
            overlayRecordsData={overlayData}
            clientId={clientId}
            recordOverrideHandler={recordOverrideHandler}
            isRecordOverridden={isRecordOverridden}
            focusIdentityButtonHandler={focusIdentityButtonHandler}
            applyAndResolveOverlayRecordHandler={
              applyAndResolveOverlayRecordHandler
            }
            skipAndReviewHandler={skipAndReviewHandler}
            fromSearchOverlay={location.state.searchOverlay}
          />
        )
      )}
    </div>
  );
}

export default OverlayReviewQueue;
